import React, { useState } from 'react';
import { OtaUpdatesOverview } from '../components/otaUpdates/OtaUpdatesOverview';
import { ScheduleUpdateModal } from '../components/otaUpdates/ScheduleUpdateModal';
import { useI18n } from '../contexts/I18nContext';
import { useClientAccess } from '../hooks/useClientAccess';
import '../styles/ota-updates.css';

/** The OTA page: a header with refresh and "add firmware", the overview, the add dialog. */
export const OtaUpdatesPage: React.FC = () => {
  // An ANEP Viewer reads this screen; uploading firmware is a manager's action and the API refuses it for anyone else.
  const { canManageFirmware } = useClientAccess();
  const { formatTime, t } = useI18n();
  const [refreshCount, setRefreshCount] = useState(0);
  const [lastUpdated, setLastUpdated] = useState<Date>(new Date());
  const [isModalOpen, setIsModalOpen] = useState(false);

  const refresh = () => {
    setRefreshCount((n) => n + 1);
    setLastUpdated(new Date());
  };

  return (
    <div className="page ota-updates-page">
      <div className="page-header">
        <div className="page-title">
          <h1>{t('otaUpdates.title')}</h1>
          <p>{t('otaUpdates.subtitle')}</p>
        </div>
        <div className="page-actions">
          <div className="last-updated">{t('common.updatedAt', { time: formatTime(lastUpdated) })}</div>
          <button type="button" className="refresh-button" onClick={refresh}>{t('common.refresh')}</button>
          {canManageFirmware && (
            <button type="button" className="schedule-update-btn" data-testid="btn-add-firmware" onClick={() => setIsModalOpen(true)}>
              <span className="add-type-icon" aria-hidden="true">+</span>
              {t('otaUpdates.addFirmware')}
            </button>
          )}
        </div>
      </div>

      <div className="page-content ota-content">
        <OtaUpdatesOverview refreshTrigger={refreshCount} />
      </div>

      <ScheduleUpdateModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onFirmwareCreated={refresh} />
    </div>
  );
};
